import { Mark, mergeAttributes } from '@tiptap/core'

/**
 * Comment extension for Tiptap editor.
 * Creates an inline span wrapping commented text ranges,
 * storing a unique comment ID and comment message/text.
 */
export const Comment = Mark.create({
  name: 'comment',

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => element.getAttribute('data-comment-id'),
        renderHTML: attributes => ({
          'data-comment-id': attributes.id,
        }),
      },
      text: {
        default: '',
        parseHTML: element => element.getAttribute('data-comment-text'),
        renderHTML: attributes => ({
          'data-comment-text': attributes.text,
        }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-comment-id]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { class: 'comment-mark' }), 0]
  },

  addCommands() {
    return {
      setComment: (text) => ({ commands }) => {
        const id = Math.random().toString(36).substr(2, 9)
        return commands.setMark(this.name, { id, text })
      },
      unsetComment: () => ({ commands }) => {
        return commands.unsetMark(this.name)
      },
    }
  }
})
